import React from 'react';
import './SubcategoryItem.css';
import { GtmService } from '../../../../../shared/src/services/gtm.service';
import {
    GtmEventClickElement,
    GtmEventComponent,
    GtmEventLocation,
} from '../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { useCurrentVerticalData } from '../../../../../shared/src/hooks/use-current-vertical-data.hook';

export const SubcategoryItem = ({
    subcategory,
    isActive,
    setCurrentSubcategoryId,
}) => {
    const { icon } = subcategory;
    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();

    const subCategoryOnClick = (subcategory) => {
        let clickAction = `select category ${subcategory.text}`;
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.GAMES_CATEGORIES,
            click_element: GtmEventClickElement.BUTTON,
            click_action: clickAction,
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });
        setCurrentSubcategoryId(subcategory.id);
    };

    return <div
        className={`asg-subcategories__item ${isActive ? 'asg-subcategories__item--active' : ''}`}
        onClick={() => subCategoryOnClick(subcategory)}
        tabIndex={0}
        onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') { subCategoryOnClick(subcategory); }
        }}
        id={`asg-subcategories__item--${subcategory.id}`}
    >
        {icon && <div
            className="asg-subcategories__item-icon"
            style={{
                WebkitMaskImage: `url("${icon}")`,
                maskImage: `url("${icon}")`,
            }}
        />}
        {subcategory.text}
    </div>;
};
